import React from 'react';

export default function TelegramInvitation() {
    return (
        <div className="telegram-invitation">
            <div className="telegram-invitation__icon">
                <img
                    src="/images/icon/social-media/telegram.webp"
                    alt="Telegram"
                />
            </div>

            <div className="telegram-invitation__content">
                <span className="telegram-invitation__title">
                    Join Our Telegram Community!
                </span>

                <p className="telegram-invitation__description">
                    Get ₱10 Welcome Credits when you join our TG group, plus ₱10
                    for every successful new-member invite!
                </p>
                <p className="telegram-invitation__description">
                    Newly joined TG members only from Oct 26, 2026. 5x rollover
                    applies.
                </p>

                <a
                    className="telegram-invitation__button"
                    href="https://t.me/fghofficialactivitygroup"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Join now
                    <span aria-hidden="true">↗</span>
                </a>
            </div>
        </div>
    );
}
